import { relations, sql } from 'drizzle-orm'
import { pgTable, primaryKey, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'
import z from 'zod/v4'

import { Price } from '../price'
import { Voucher } from './voucher'

export const VoucherToPrice = pgTable(
  'voucher_to_price',
  {
    voucherId: uuid()
      .notNull()
      .references(() => Voucher.id, { onDelete: 'cascade' }),
    priceId: uuid()
      .notNull()
      .references(() => Price.id, { onDelete: 'cascade' }),
    createdAt: timestamp({ mode: 'date', withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true }).$onUpdateFn(() => sql`now()`),
  },
  (t) => [primaryKey({ columns: [t.voucherId, t.priceId] })],
)

export const voucherToPriceRelations = relations(VoucherToPrice, ({ one }) => ({
  voucher: one(Voucher, {
    fields: [VoucherToPrice.voucherId],
    references: [Voucher.id],
  }),

  price: one(Price, {
    fields: [VoucherToPrice.priceId],
    references: [Price.id],
  }),
}))

export const InsertVoucherToPriceSchema = createInsertSchema(VoucherToPrice, {
  voucherId: z.uuid(),
  priceId: z.uuid(),
}).omit({
  createdAt: true,
  updatedAt: true,
})

export const UpdateVoucherToPriceSchema = createUpdateSchema(VoucherToPrice, {})
  .omit({
    voucherId: true,
    priceId: true,
    createdAt: true,
    updatedAt: true,
  })
  .partial()

export const SelectVoucherToPriceSchema = createSelectSchema(VoucherToPrice, {
  voucherId: z.uuid(),
  priceId: z.uuid(),
  createdAt: z.date(),
  updatedAt: z.date().nullable(),
})

export type InsertVoucherToPrice = typeof VoucherToPrice.$inferInsert
export type UpdateVoucherToPrice = z.infer<typeof UpdateVoucherToPriceSchema>
export type SelectVoucherToPrice = typeof VoucherToPrice.$inferSelect
